const { createSelector } = require("reselect");

const selectAllOrders = (state) => state["marketplace.marketOrder"].allOrders;

const allOrders = () => createSelector([selectAllOrders], (show) => show.data);

const allOrdersError = () =>
  createSelector([selectAllOrders], (show) => show.error);

const allOrdersLoading = () =>
  createSelector([selectAllOrders], (show) => show.loading);

const selectToShipOrder = (state) =>
  state["marketplace.marketOrder"].toShipOrders;

const toShipOrder = () =>
  createSelector([selectToShipOrder], (show) => show.data);

const toShipOrderError = () =>
  createSelector([selectToShipOrder], (show) => show.error);

const toShipOrderLoading = () =>
  createSelector([selectToShipOrder], (show) => show.loading);

const selectToPayOrders = (state) =>
  state["marketplace.marketOrder"].toPayOrders;

const toPayOrders = () =>
  createSelector([selectToPayOrders], (cncl) => cncl.data);

const toPayOrdersError = () =>
  createSelector([selectToPayOrders], (cncl) => cncl.error);

const toPayOrdersLoading = () =>
  createSelector([selectToPayOrders], (cncl) => cncl.loading);

const selectToPackOrders = (state) =>
  state["marketplace.marketOrder"].toPackOrders;

const toPackOrders = () =>
  createSelector([selectToPackOrders], (rcv) => rcv.data);

const toPackOrdersError = () =>
  createSelector([selectToPackOrders], (rcv) => rcv.error);

const toPackOrdersLoading = () =>
  createSelector([selectToPackOrders], (rcv) => rcv.loading);

const selectToRecieveOrders = (state) =>
  state["marketplace.marketOrder"].toRecieveOrders;

const toRecieveOrders = () =>
  createSelector([selectToRecieveOrders], (rcv) => rcv.data);

const toRecieveOrdersError = () =>
  createSelector([selectToRecieveOrders], (rcv) => rcv.error);

const toRecieveOrdersLoading = () =>
  createSelector([selectToRecieveOrders], (rcv) => rcv.loading);

const selectToCompleteOrders = (state) =>
  state["marketplace.marketOrder"].toCompleteOrders;

const toCompleteOrders = () =>
  createSelector([selectToCompleteOrders], (rcv) => rcv.data);

const toCompleteOrdersError = () =>
  createSelector([selectToCompleteOrders], (rcv) => rcv.error);

const toCompleteOrdersLoading = () =>
  createSelector([selectToCompleteOrders], (rcv) => rcv.loading);

const selectToReturnOrders = (state) =>
  state["marketplace.marketOrder"].returnOrders;

const returnOrders = () =>
  createSelector([selectToReturnOrders], (rcv) => rcv.data);

const returnOrdersError = () =>
  createSelector([selectToReturnOrders], (rcv) => rcv.error);

const returnOrdersLoading = () =>
  createSelector([selectToReturnOrders], (rcv) => rcv.loading);

const selectCancelOrders = (state) =>
  state["marketplace.marketOrder"].cancelOrders;

const cancelOrders = () =>
  createSelector([selectCancelOrders], (rcv) => rcv.data);

const cancelOrdersError = () =>
  createSelector([selectCancelOrders], (rcv) => rcv.error);

const cancelOrdersLoading = () =>
  createSelector([selectCancelOrders], (rcv) => rcv.loading);

const selectOrdersDetails = (state) =>
  state["marketplace.marketOrder"].ordersDetails;

const ordersDetails = () =>
  createSelector([selectOrdersDetails], (rcv) => rcv.data);

const ordersDetailsError = () =>
  createSelector([selectOrdersDetails], (rcv) => rcv.error);

const ordersDetailsLoading = () =>
  createSelector([selectOrdersDetails], (rcv) => rcv.loading);

const selectcancelTheOrders = (state) =>
  state["marketplace.marketOrder"].cancelTheOrders;

const cancelTheOrders = () =>
  createSelector([selectcancelTheOrders], (rcv) => rcv.data);

const cancelTheOrdersError = () =>
  createSelector([selectcancelTheOrders], (rcv) => rcv.error);

const cancelTheOrdersLoading = () =>
  createSelector([selectcancelTheOrders], (rcv) => rcv.loading);

const selectrecievedOrders = (state) =>
  state["marketplace.marketOrder"].recievedOrders;

const recievedOrders = () =>
  createSelector([selectrecievedOrders], (rcv) => rcv.data);

const recievedOrdersError = () =>
  createSelector([selectrecievedOrders], (rcv) => rcv.error);

const recievedOrdersLoading = () =>
  createSelector([selectrecievedOrders], (rcv) => rcv.loading);

const selectToAcceptOrders = (state) =>
  state["marketplace.marketOrder"].toAcceptOrders;

const toAcceptOrders = () =>
  createSelector([selectToAcceptOrders], (rcv) => rcv.data);

const toAcceptOrdersError = () =>
  createSelector([selectToAcceptOrders], (rcv) => rcv.error);

const toAcceptOrdersLoading = () =>
  createSelector([selectToAcceptOrders], (rcv) => rcv.loading);

const selectToRedeemOrders = (state) =>
  state["marketplace.marketOrder"].toRedeemOrders;

const toRedeemOrders = () =>
  createSelector([selectToRedeemOrders], (rcv) => rcv.data);

const toRedeemOrdersError = () =>
  createSelector([selectToRedeemOrders], (rcv) => rcv.error);

const toRedeemOrdersLoading = () =>
  createSelector([selectToRedeemOrders], (rcv) => rcv.loading);
module.exports = {
  allOrders,
  allOrdersLoading,
  allOrdersError,

  toShipOrder,
  toShipOrderLoading,
  toShipOrderError,

  toPayOrders,
  toPayOrdersLoading,
  toPayOrdersError,

  toPackOrders,
  toPackOrdersLoading,
  toPackOrdersError,

  toRecieveOrders,
  toRecieveOrdersLoading,
  toRecieveOrdersError,

  toCompleteOrders,
  toCompleteOrdersLoading,
  toCompleteOrdersError,

  returnOrders,
  returnOrdersLoading,
  returnOrdersError,

  cancelOrders,
  cancelOrdersLoading,
  cancelOrdersError,

  ordersDetails,
  ordersDetailsLoading,
  ordersDetailsError,

  cancelTheOrders,
  cancelTheOrdersLoading,
  cancelTheOrdersError,

  recievedOrders,
  recievedOrdersLoading,
  recievedOrdersError,

  toAcceptOrders,
  toAcceptOrdersLoading,
  toAcceptOrdersError,

  toRedeemOrders,
  toRedeemOrdersLoading,
  toRedeemOrdersError,
};
